import React, { Component } from 'react';
import { Row, Col, Card, Space, Typography, Radio, Modal } from 'antd';
import Header from '../Header';
import ReactAudioPlayer from 'react-audio-player';
import { withTranslation } from 'react-i18next';
import CButton from '../../../../../../../components/Button';

const { Text } = Typography;

export class S1Part1 extends Component {
  constructor(props) {
    super(props)
    
    const arrRef = ['1', '2']
    this.audioRef = arrRef.map(() => React.createRef())

    this.state = {
      visibleSection: false
    }
  }

  showModalSection = () => {
    this.setState({ visibleSection: true})
  }

  handleCancel = () => {
    this.setState({
      visibleSection: false
    })
  }

  handlePlay = (i) => {
    this.audioRef.map((item, iRef) => 
      i === iRef  ? item.current.audioEl.current.play() : item.current.audioEl.current.pause()
    )
  }

  render() {
    const { questionListening, handleSelect, handleNext, result, t } = this.props
    const { visibleSection } = this.state
    // const arrQuestion = Math.questionListening(Math.random() * ( + 1));
    const arrQuestion = questionListening.filter((res,i) => i < 2)
    return (
      <React.Fragment>
        <Row className='mt-16'>
          <Col lg={{ span: 20, offset: 2 }} xxl={{ span: 18, offset: 3 }}>
            <Header {...this.props} />

            <Card className="card-body-question mt-16 mb-16 border-radius-8">
              <Row gutter={[64,32]}>
                <Col span={24}>
                  <Space className="text-align-center width-100" direction="vertical" size={0}>
                    <Text className='dark-color fs-20' style={{ fontWeight: 'normal', fontStyle: 'italic' }} strong>Listening</Text>
                    <Text className='dark-color fs-16' style={{ fontWeight: '600', fontStyle: 'italic' }} strong>Section 1</Text>
                  </Space>
                </Col>
                {
                  arrQuestion.map((item, i) =>
                    <Col key={i} span={24}>
                      <Space className="width-100" align="start">
                        <Text>{i+1}.</Text>
                        <Space className='width-100' direction="vertical">
                          <Space className='width-100' direction='vertical'>
                            <ReactAudioPlayer
                              ref={this.audioRef[i]}
                              src={item.audio}
                              autoPlay={false}
                              controls
                              controlsList="nodownload noplaybackrate"
                              onPlay={() => this.handlePlay(i)}
                            />
                            <Space direction='vertical' size={0}>
                              <Text className='noselect' style={{ fontSize: 15, fontWeight: 'normal', fontStyle: 'italic', color: '#FF0000'}} strong>Choose the correct option to answer the question.</Text>
                              <Text className='noselect' style={{ fontSize: 15, fontWeight: 'normal', color: '#FF0000' }}>Pilih jawaban yang tepat untuk menjawab pertanyaan berikut.</Text>
                            </Space>
                            <Text className='noselect dark-color fs-15' strong>Question:</Text>
                            <Text className='noselect dark-color' style={{ fontSize: 15, fontWeight: 'normal' }}>{item.question}</Text>
                          </Space>
                          <Radio.Group className='width-100' value={result?.find(item => item.no === i+1)?.selected} onChange={(e) => handleSelect(e,i+1)}>
                            <Space className="width-100" direction="vertical">
                              <Space className="width-100" direction="vertical">
                                {
                                  item.answers.map((res,iAnswer) =>
                                    <Radio className='noselect' key={iAnswer} result={res.value} value={iAnswer} style={{ whiteSpace: 'break-spaces', display: 'flex', alignItems: 'center' }} >{res.answerLabel}</Radio>
                                  )
                                }
                              </Space>
                            </Space>
                          </Radio.Group>
                        </Space>
                      </Space>
                    </Col>
                  )
                }
                <Col className='mt-16' span={24}>
                  <Space className='float-right'>
                    <CButton type="primary-icon" size="large" action={result?.length<2 ? () => handleNext(2,0,result?.length>=2) : this.showModalSection} title={t('pathway.next')} icon="RightOutlined"/>
                  </Space>
                </Col>
              </Row>
            </Card>
          </Col>
        </Row>

        <Modal
          width={600}
          title={
            <Space className="text-align-center width-100" direction="vertical" size={0}>
              <Text className="fs-20 primary-color">{t('pathway.nextSession')} </Text>
              <Text className="fs-15 dark-color">
                {/* {t('pathway.titleMiniEnglish')} */}
                Mini English Test
              </Text>
            </Space>
          }
          visible={visibleSection}
          onCancel={this.handleCancel}
          footer={false}
        >
          <Row className='text-align-center'>
            <Col span={24}>
              <Space direction='vertical' size={16}>
                <Space className='font-style-italic text-align-center width-100' direction='vertical' size={0}>
                  <Text style={{ fontSize: 15, fontWeight: 'normal' }}>Are you sure you want to submit this session?</Text>
                  <Text style={{ fontSize: 15, fontWeight: 'normal' }}>Once Submitted, you won't be able to change your answers.</Text>
                </Space>
                <Space className='text-align-center width-100' direction='vertical' size={0}>
                  <Text className='dark-color' strong style={{ fontSize: 15, fontWeight: 'normal' }}> Apakah anda yakin ingin mengumpulkan sesi ini</Text>
                  <Text className='dark-color' strong style={{ fontSize: 15, fontWeight: 'normal' }}> Setelah mengumpulkan, Anda tidak dapat mengubah jawaban Anda.</Text>
                </Space>
              </Space>
              <Row className='mt-32'>
                <Col lg={{ span: 6, offset: 9 }} xs={{ span: 24, offset: 0 }}>
                  <CButton type="primary" size="large" block action={() => handleNext(2,0,result?.length>=2)} title="Oke"/>
                </Col>
              </Row>
            </Col>
          </Row>
        </Modal>

      </React.Fragment>
    )
  }
}

export default withTranslation()(S1Part1)
